import {
  filterK8Grades,
  sortGradesWithKFirst,
  filterDwbGrades,
  sortDwbGradesWithKFirst,
  getRelevantCourseList,
} from 'experienceComponents/CreateInstanceShared/dataUtils'
import {
  convertGradeToDisplayValue,
  convertGradeNameToLabel,
  getProgramName,
  getDwbCourseCodeFromGradeLabel,
  createViewClassBehavior,
} from './data'

// Filter and sort configuration
export const courseFilterConfig = {
  filterFunction: filterK8Grades,
  sortFunction: sortGradesWithKFirst,
  getRelevantCourseList: courses => getRelevantCourseList(courses, false), // false = classes
  convertGradeToDisplayValue: convertGradeToDisplayValue,
  isSmallGroup: false, // Explicit flag - don't rely on function name matching
}

export const dwbCourseFilterConfig = {
  filterFunction: filterDwbGrades,
  sortFunction: sortDwbGradesWithKFirst,
  getRelevantCourseList: courses => getRelevantCourseList(courses, false),
  convertGradeToDisplayValue,
  isSmallGroup: false,
  isDigitalWellBeing: true,
}

// Program mapping configuration
export const courseProgramConfig = {
  convertGradeNameToLabel: convertGradeNameToLabel,
  getProgramName: getProgramName,
  isDigitalWellBeing: false,
}

export const dwbCourseProgramConfig = {
  convertGradeNameToLabel,
  getDwbCourseCodeFromGradeLabel,
  isDigitalWellBeing: true,
}

// View class behavior configuration
export const courseViewClassConfig = {
  createViewClassBehavior: createViewClassBehavior,
}
